;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();export const fragment = /* GraphQL */ `
    fragment CardTestimonialFragment on CardTestimonial {
        quoteIconColor
        mainQuote
        mainQuoteRichText {
            json
        }
        secondaryQuote
        secondaryQuoteRichText {
            json
        }
        author
        authorDescription
        authorImage {
            ...Asset
        }
    }
`;
